import { ValidationProvider } from '../../contexts/ValidationContext';
import { ValidationV2Provider } from '../../contexts/ValidationV2Context';

import ValidationPageV2 from './ValidationPageV2';

const ValidationV2Wrapper = () => {
  return (
    <ValidationV2Provider>
      <ValidationProvider>
        <ValidationPageV2 />
      </ValidationProvider>
    </ValidationV2Provider>
  );
};

export default ValidationV2Wrapper;
